"use client";

import Image from "next/image";
import { ArrowRight, X } from "lucide-react";
import { useState, type ReactNode } from "react";

import { Link } from "@/i18n/navigation";
import { Credenza, CredenzaClose, CredenzaContent, CredenzaDescription, CredenzaTitle, CredenzaTrigger } from "@/components/shared/credenza";
import styles from "./PressAnnouncementPopup.module.css";

const ARTICLE_PATH = "/about/news/studystash-joins-kortext";

export function PressAnnouncementPopup({ children }: { children: ReactNode }) {
	const [open, set_open] = useState(false);

	return (
		<Credenza open={open} onOpenChange={set_open}>
			<CredenzaTrigger asChild>{children}</CredenzaTrigger>
			<CredenzaContent className={styles.content}>
				<div className={styles.photo}>
					<Image
						src="/press/studystash-founders.jpg"
						alt="Ben Ward and Jonathan Graham, co-founders of StudyStash"
						width={1600}
						height={1067}
						sizes="(max-width: 767px) 100vw, 520px"
						loading="eager"
					/>
					<CredenzaClose asChild>
						<button type="button" className={styles.close} aria-label="Close announcement">
							<X size={20} aria-hidden="true" />
						</button>
					</CredenzaClose>
				</div>
				<div className={styles.body}>
					<div className={styles.partners} aria-label="StudyStash and Kortext">
						<Image
							src="/StudyStash - Logo_Colour - RGB.png"
							alt="StudyStash"
							width={144}
							height={32}
							className={styles.studyStashLogo}
						/>
						<span aria-hidden="true">+</span>
						<Image
							src="/press/kortext-logo.png"
							alt="Kortext, established 2013"
							width={1956}
							height={508}
							sizes="120px"
							className={styles.kortextLogo}
						/>
					</div>
					<CredenzaTitle className={styles.title}>StudyStash joins Kortext.</CredenzaTitle>
					<CredenzaDescription className={styles.description}>
						We’ve joined Kortext to bring StudyStash to thousands of institutions.
					</CredenzaDescription>
					<Link href={ARTICLE_PATH} className={styles.cta} onClick={() => set_open(false)}>
						Read the announcement <ArrowRight size={18} aria-hidden="true" />
					</Link>
					<CredenzaClose asChild>
						<button type="button" className={styles.dismiss}>Keep exploring</button>
					</CredenzaClose>
				</div>
			</CredenzaContent>
		</Credenza>
	);
}
